module.exports = __webpack_public_path__ + "img/user-management-icon.8b3903f4.svg";